export type ClinicBookingContent = {
  name: string;
  role: string;
  registration: string;
  service: string;
  address: string;
  about: string;
  photoUrl?: string;
  timezone: string;
  durationMinutes: number;
  priceCents: number;
  /** What the professional offers; content from before services lists its single one. */
  services?: ClinicBookingService[];
};
export type ClinicBookingService = { id: string; name: string; durationMinutes: number; priceCents: number; description?: string };
/** Services of a booking profile, with the single legacy service as the fallback. */
export const servicesOf = (p: ClinicBookingContent): ClinicBookingService[] =>
  p.services?.length ? p.services : [{ id: 'principal', name: p.service, durationMinutes: p.durationMinutes, priceCents: p.priceCents }];
export type ClinicBookingSlot = { id: string; startsAt: string; endsAt: string; status?: string };
export type ClinicBookingPublic = {
  clinicName: string;
  professional: ClinicBookingContent & { id: string };
  slots: ClinicBookingSlot[];
  consentVersion: string;
};
export type ClinicBookingProfile = {
  id: string;
  membershipId: string;
  version: number;
  draft: ClinicBookingContent;
  published: ClinicBookingContent | null;
  slots: ClinicBookingSlot[];
};
export type ClinicBookingEditorState = {
  clinic: { id: string; name: string; slug: string };
  members: { id: string; name: string }[];
  profiles: ClinicBookingProfile[];
};
export type ClinicBookingRequest = {
  id: string;
  patientName: string;
  phone: string;
  patientEmail?: string | null;
  status: 'pending' | 'accepted' | 'rejected';
  consentAt: string;
  publicSnapshot: ClinicBookingContent;
  slot: Pick<ClinicBookingSlot, 'startsAt' | 'endsAt'>;
  /** Present once the request became a clinic session. */
  session?: { id: string } | null;
};
export type ClinicBookingMutation =
  | { action: 'save'; content: ClinicBookingContent; membershipId: string; version: number }
  | { action: 'publish' | 'unpublish'; id: string; version: number }
  | { action: 'slot'; id: string; date: string; time: string }
  | { action: 'close'; id: string };
